const KEY = 'ftlo.pending-code';
const WINDOW_MS = 10 * 60 * 1000;

export function loadPendingCode(): string | null {
  const raw = window.localStorage.getItem(KEY);
  if (raw === null) return null;
  const pending = JSON.parse(raw) as { email: string; expiresAt: number };
  if (pending.expiresAt <= Date.now()) {
    window.localStorage.removeItem(KEY);
    return null;
  }
  return pending.email;
}

export function savePendingCode(email: string): void {
  window.localStorage.setItem(
    KEY,
    JSON.stringify({ email, expiresAt: Date.now() + WINDOW_MS }),
  );
}

export function clearPendingCode(): void {
  window.localStorage.removeItem(KEY);
}
